import { Action } from 'redux'
import { IGetGoogleAuth } from '@app-store/slices/emailCredential/getGoogleAuthUrl'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: IGetGoogleAuth
}

const { onRequest, onSuccess, onFailure } = rootActions.emailCredential.getGoogleAuthUrl

function* getGoogleAuthURLTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/notifications/email-credentials/google-auth-url`)
        if (response.success) {
            yield put(onSuccess(response.result))
            window.open(response.result.url, '', 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100')
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result.url)
        } else {
            throw new Error('')
        }
    } catch (error) {
        if (payload?.sagaCB?.onError) payload.sagaCB.onError(error)
        yield put(onFailure(error))
    }
}

function* getGoogleAuthURL(): any {
    yield takeLatest<TaskAction>(onRequest, getGoogleAuthURLTask)
}

export default getGoogleAuthURL
